module.exports = __webpack_public_path__ + "img/skull_intelligence.bf392095.png";